import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#030303",
    },
    secondary: {
      main: "#ff784b",
    },
    success: {
      main: "#32bc9b",
    },
    background: {
      default: "#f2f2f2",
    },
  },
});
